import { createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Theme {
    customHeader: {
      backgroundImage: string;
      backgroundSize: string;
      backgroundPosition: string;
      backgroundRepeat: string;
      overflow: string;
      buttonBgColor: string;
      buttonHoverBgColor: string;
    };
  }
  interface ThemeOptions {
    customHeader?: {
      backgroundImage?: string;
      backgroundSize?: string;
      backgroundPosition?: string;
      backgroundRepeat?: string;
      overflow?: string;
      buttonBgColor?: string;
      buttonHoverBgColor?: string;
    };
  }
}

export const ediphorTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#4ECDC4',
    },
    secondary: {
      main: '#3dbdb5',
    },
    background: {
      default: '#ffffff',
      paper: '#f8f9fa',
    },
    text: {
      primary: '#1a1d24',
      secondary: '#6b7280',
    },
    divider: 'rgba(78, 205, 196, 0.12)',
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      'Segoe UI',
      'Roboto',
      'Helvetica Neue',
      'Arial',
      'sans-serif',
    ].join(','),
  },
  customHeader: {
    backgroundImage: 'url(/images/molecules-navbar-bg.png)',
    backgroundSize: '100% auto',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    overflow: 'hidden',
    buttonBgColor: 'whitesmoke',
    buttonHoverBgColor: 'gainsboro',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 10,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#f8f9fa',
          color: '#ffffff',
          boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          backgroundColor: '#f8f9fa',
          borderRadius: 8,
        },
      },
    },
  },
});
